function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ae42;}.cls-2{fill:#fff;}.cls-3{fill:#231f20;}.cls-4{fill:#ffd100;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,0V36H94V0ZM80,14.84,73.9,19.33l-5.67-4.49H.27V.27H93.73V14.84Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "0.27 0.27 0.27 14.84 68.23 14.84 73.9 19.33 80.01 14.84 93.73 14.84 93.73 0.27 0.27 0.27"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M5.63,10.29a.57.57,0,0,1-.23-.45A.55.55,0,0,1,6,9.29a.54.54,0,0,1,.35.11,2.88,2.88,0,0,0,1.87.69c.72,0,1.18-.35,1.18-.84v0c0-.48-.27-.74-1.51-1-1.42-.35-2.22-.77-2.22-2v0A2,2,0,0,1,7.9,4.26,3.68,3.68,0,0,1,10,4.88a.53.53,0,0,1,.26.46.55.55,0,0,1-.56.55.53.53,0,0,1-.3-.09,2.81,2.81,0,0,0-1.54-.5c-.69,0-1.09.35-1.09.79v0c0,.51.31.74,1.6,1s2.13.85,2.13,1.95v0c0,1.25-1,2-2.38,2A4.17,4.17,0,0,1,5.63,10.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M13.07,5.44H11.45a.55.55,0,1,1,0-1.09h4.43a.55.55,0,0,1,0,1.09H14.25V10.5a.58.58,0,0,1-.59.58.59.59,0,0,1-.59-.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M15.75,10.27l2.48-5.54a.75.75,0,0,1,.71-.47h0a.73.73,0,0,1,.7.47l2.48,5.54a.47.47,0,0,1,.07.25.55.55,0,0,1-.55.56.61.61,0,0,1-.58-.41l-.54-1.25H17.33l-.57,1.29a.55.55,0,0,1-.54.37.54.54,0,0,1-.55-.55A.56.56,0,0,1,15.75,10.27Zm4.37-1.89L19,5.68l-1.18,2.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M23.26,4.94a.58.58,0,0,1,.59-.59h2.38A2.7,2.7,0,0,1,28.16,5a2,2,0,0,1,.55,1.44v0a2,2,0,0,1-1.51,2l1.27,1.62a.64.64,0,0,1,.2.44.56.56,0,0,1-.57.55.68.68,0,0,1-.57-.31L25.91,8.7H24.43v1.8a.59.59,0,0,1-1.17,0Zm2.89,2.72c.84,0,1.37-.44,1.37-1.11v0c0-.72-.51-1.11-1.38-1.11H24.43V7.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M31.32,5.44H29.7a.55.55,0,1,1,0-1.09h4.43a.55.55,0,0,1,0,1.09H32.5V10.5a.59.59,0,0,1-.59.58.58.58,0,0,1-.59-.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M50,10.29a.55.55,0,0,1,.32-1,.51.51,0,0,1,.34.11,2.92,2.92,0,0,0,1.87.69c.73,0,1.19-.35,1.19-.84v0c0-.48-.27-.74-1.51-1-1.42-.35-2.22-.77-2.22-2v0a2,2,0,0,1,2.28-1.93,3.71,3.71,0,0,1,2.12.62.52.52,0,0,1,.25.46.54.54,0,0,1-.55.55.59.59,0,0,1-.31-.09,2.78,2.78,0,0,0-1.53-.5c-.69,0-1.09.35-1.09.79v0c0,.51.31.74,1.59,1s2.14.85,2.14,1.95v0c0,1.25-1,2-2.38,2A4.17,4.17,0,0,1,50,10.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M56.18,10.44V4.94a.59.59,0,0,1,.6-.59h3.88a.52.52,0,0,1,.52.53.52.52,0,0,1-.52.52h-3.3V7.14h2.87a.52.52,0,0,1,.52.53.52.52,0,0,1-.52.52H57.36V10h3.35a.53.53,0,0,1,.52.53.52.52,0,0,1-.52.52H56.78A.59.59,0,0,1,56.18,10.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M62.26,10.29A.57.57,0,0,1,62,9.84a.55.55,0,0,1,.56-.55.53.53,0,0,1,.34.11,2.9,2.9,0,0,0,1.87.69c.73,0,1.18-.35,1.18-.84v0c0-.48-.26-.74-1.5-1-1.43-.35-2.23-.77-2.23-2v0a2,2,0,0,1,2.28-1.93,3.68,3.68,0,0,1,2.12.62.53.53,0,0,1,.26.46.55.55,0,0,1-.55.55.56.56,0,0,1-.31-.09,2.79,2.79,0,0,0-1.54-.5c-.68,0-1.08.35-1.08.79v0c0,.51.3.74,1.59,1s2.14.85,2.14,1.95v0c0,1.25-1,2-2.39,2A4.21,4.21,0,0,1,62.26,10.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M67.92,10.27,70.4,4.73a.76.76,0,0,1,.71-.47h.06a.73.73,0,0,1,.69.47l2.48,5.54a.47.47,0,0,1,.07.25.55.55,0,0,1-.55.56.61.61,0,0,1-.58-.41l-.54-1.25H69.5l-.57,1.29a.55.55,0,0,1-.54.37.54.54,0,0,1-.54-.55A.68.68,0,0,1,67.92,10.27Zm4.37-1.89-1.17-2.7L70,8.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M75.43,4.91a.59.59,0,0,1,.59-.6h.12a.64.64,0,0,1,.55.32l2,3.17,2-3.18a.61.61,0,0,1,.54-.31h.12a.59.59,0,0,1,.59.6V10.5a.58.58,0,0,1-.59.58.59.59,0,0,1-.58-.58v-4L79.19,8.94a.55.55,0,0,1-1,0L76.58,6.51v4a.58.58,0,0,1-1.15,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M83.65,10.44V4.94a.58.58,0,0,1,.59-.59h3.88a.53.53,0,0,1,.53.53.52.52,0,0,1-.53.52h-3.3V7.14h2.87a.53.53,0,0,1,.53.53.52.52,0,0,1-.53.52H84.82V10h3.35a.53.53,0,0,1,.53.53.52.52,0,0,1-.53.52H84.24A.58.58,0,0,1,83.65,10.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M35.83,6.66a.6.6,0,0,1,0-.12.32.32,0,0,1,.34-.32.33.33,0,0,1,.32.23l.59,1.83.59-1.81A.35.35,0,0,1,38,6.21h0a.34.34,0,0,1,.33.26L39,8.28l.59-1.83a.33.33,0,0,1,.64.08.61.61,0,0,1,0,.13L39.34,9a.37.37,0,0,1-.34.27h-.07A.36.36,0,0,1,38.59,9L38,7.29,37.42,9a.36.36,0,0,1-.34.27H37A.36.36,0,0,1,36.67,9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M41,6.54a.33.33,0,0,1,.65,0V8.92a.33.33,0,1,1-.65,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M43.06,6.85h-.63a.31.31,0,0,1,0-.61h1.92a.31.31,0,0,1,0,.61h-.63V8.92a.33.33,0,1,1-.66,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M45.13,6.54a.33.33,0,0,1,.66,0v.88H47V6.54a.32.32,0,0,1,.33-.32.32.32,0,0,1,.33.32V8.92a.33.33,0,0,1-.33.33A.32.32,0,0,1,47,8.92V8H45.79v.89a.33.33,0,1,1-.66,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M47.44,5.24H36.14a.45.45,0,0,1,0-.89h11.3a.45.45,0,0,1,0,.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M47.44,11H36.14a.44.44,0,0,1-.44-.44.44.44,0,0,1,.44-.44h11.3a.43.43,0,0,1,.44.44A.44.44,0,0,1,47.44,11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M5.88,28.82A.73.73,0,0,1,6.57,28c.61,0,1.06.91,2.1.91a1.52,1.52,0,0,0,1.62-1.62c0-2-4-2.07-4-5.11a2.63,2.63,0,0,1,2.89-2.71c1.31,0,2.37.62,2.37,1.37a.74.74,0,0,1-.69.77c-.48,0-.86-.51-1.58-.51A1.16,1.16,0,0,0,8,22.32c0,1.91,4,1.88,4,5a3.09,3.09,0,0,1-3.32,3.24C7.2,30.57,5.88,29.76,5.88,28.82Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M13.7,29.65a.93.93,0,1,1,.93.92A.88.88,0,0,1,13.7,29.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M17.8,29.45V20.63a.86.86,0,0,1,.93-1h3.84c.55,0,.89.29.89.78s-.34.78-.89.78H19.91c-.28,0-.42.11-.42.32v2.31c0,.22.16.34.42.34h2.23a.68.68,0,0,1,.77.7.7.7,0,0,1-.77.74H19.91c-.28,0-.42.11-.42.34v2.54c0,.23.14.33.42.33h2.66a.78.78,0,0,1,.89.79c0,.49-.34.78-.89.78H18.73A.86.86,0,0,1,17.8,29.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M25.65,29.65a.9.9,0,0,1,.94-.94.89.89,0,0,1,.92.94.88.88,0,0,1-.92.92A.89.89,0,0,1,25.65,29.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M29.7,29.42V20.48a.85.85,0,1,1,1.69,0v7.93a.33.33,0,0,0,.37.38h2.31c.58,0,.92.31.92.82s-.34.81-.92.81H30.66A.9.9,0,0,1,29.7,29.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M36.86,29.65a.9.9,0,0,1,.94-.94.89.89,0,0,1,.92.94.88.88,0,0,1-.92.92A.89.89,0,0,1,36.86,29.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M40.59,29.61v-9a.86.86,0,0,1,.93-1h3.84c.55,0,.89.29.89.78s-.34.78-.89.78H42.61a.31.31,0,0,0-.33.32v2.36a.3.3,0,0,0,.33.32h2.26c.52,0,.83.27.83.75s-.31.75-.83.75H42.61a.31.31,0,0,0-.33.34v3.54a.85.85,0,1,1-1.69,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M45.58,29.65a.9.9,0,0,1,.94-.94.89.89,0,0,1,.92.94.88.88,0,0,1-.92.92A.89.89,0,0,1,45.58,29.65Z"
})));

function SvgStartWithSesameVAbrv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartWithSesameVAbrv);
export default __webpack_public_path__ + "static/media/StartWithSesame_V_Abrv.341f6576.svg";
export { ForwardRef as ReactComponent };